// El atributo `external-payment` del `<rebill-checkout>` (`RebillCardPayment`): la metadata
// que viaja al webhook para saber de quién es el pago. `customer: {}` es obligatorio: sin él
// el SDK crashea en setPayment (accede customer.email).
//
// `metadataExtra` (facturación por marca, ADR-2026-10-28-elegir-plan-de-marca) se suma
// encima: `{ brand_id, plan, tipo: 'marca', … }`. Sin él, el resultado es el de siempre:
// `null` sin empresa (no se setea el atributo) y `{ id_company, user_id }` con empresa.

export interface ExternalPaymentDeRebill {
  customer: Record<string, never>;
  metadata: Record<string, string>;
}

export function externalPaymentDeRebill(
  companyCtx: { idCompany: string; userId: string } | null,
  metadataExtra?: Record<string, string>,
): ExternalPaymentDeRebill | null {
  if (!companyCtx && !metadataExtra) return null;
  return {
    customer: {},
    metadata: {
      ...(companyCtx ? { id_company: companyCtx.idCompany, user_id: companyCtx.userId } : {}),
      ...(metadataExtra ?? {}),
    },
  };
}
